import { Load, Spinner } from "../styles/Loader";


export default function Loader() {
  return (
    <Load>
      <Spinner />
    </Load>
  );
} 